export default __webpack_public_path__ + "assets/images/becc063b9503e4a451186356bf00f2f2.webp";